import { RouteConfig } from "vue-router";
import { LayoutBlock, LayoutDefault, LayoutBlockKeepAlive } from "@/layout";

const recurringLaborRouting: RouteConfig[] = [
  {
    path: "recurringLabor",
    meta: { title: "连续劳务" },
    component: LayoutBlockKeepAlive,
    redirect: "/app/recurringLabor/paymentDetails",
    children: [
      {
        path: "paymentDetails",
        component: () => import("./paymentDetails/index.vue"),
        meta: { title: "发放明细" },
      },
      {
        path: "tax",
        component: () => import("./tax/index.vue"),
        meta: { title: "报税明细" },
      },
    ],
  },
];
export default recurringLaborRouting;
